module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSI2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPGNpcmNsZSBjeD0iMyIgY3k9IjEyIiByPSIzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC05KSIgZmlsbD0iIzBFNUNGNCIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/icons/oval.svg
// module id = Ad8T
// module chunks = 88